export default __webpack_public_path__ + "static/media/Authentech Software logo.d9e07776.png";